"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskState = void 0;
var TaskState;
(function (TaskState) {
    TaskState[TaskState["Created"] = 0] = "Created";
    TaskState[TaskState["Pending"] = 1] = "Pending";
    TaskState[TaskState["Done"] = 2] = "Done";
    TaskState[TaskState["Error"] = 3] = "Error";
})(TaskState || (exports.TaskState = TaskState = {}));
